export default __webpack_public_path__ + "static/media/ai.da5e6f1d.svg";